import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router/index'
import '../util/global'//全局
import './promissionRouter'//这里进行路由后台获取的模拟
import i18n from './lang' // Internationalization
import Cookies from 'js-cookie'
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import '@/styles/index.scss'
import '@/styles/pulish.css'
import '@/styles/other.css'
import VCharts from "v-charts";

Vue.use(ElementUI, {
    size: Cookies.get('size') || 'medium', // set element-ui default size
    i18n: (key, value) => i18n.t(key, value)
});
Vue.use(VCharts);

Vue.directive('alterELDialogMarginTop'/*修改elementUI中el-dialog顶部的距离,传入值eg:{marginTop:'5vh'} */, {
    inserted(el, binding, vnode) {
              el.firstElementChild.style.marginTop = binding.value.marginTop
    }
})


import 'font-awesome/css/font-awesome.min.css'

Vue.config.productionTip = false

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js